import { DecoratorNode } from 'lexical';
import React from 'react';

function MentionComponent({ value }) {
  return (
    <span
      style={{
        color: '#1976d2',
        backgroundColor: '#e3f2fd',
        padding: '2px 6px',
        borderRadius: '4px',
        fontWeight: 'bold',
      }}
    >
      @{value}
    </span>
  );
}

export class MentionNode extends DecoratorNode {
  static getType() {
    return 'mention';
  }

  static clone(node) {
    return new MentionNode(node.__value, node.__key);
  }

  constructor(value, key) {
    super(key);
    this.__value = value;
  }

  createDOM() {
    const span = document.createElement('span');
    return span;
  }

  updateDOM() {
    return false;
  }

  decorate() {
    return <MentionComponent value={this.__value} />;
  }

  static importJSON(serializedNode) {
    return new MentionNode(serializedNode.value);
  }

  exportJSON() {
    return {
      type: 'mention',
      value: this.__value,
      version: 1,
    };
  }
}
